import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class Refresh {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * Refresh constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Refresh an access token using a refresh token.
     *
     * @returns {Promise}
     */
    handle() {
        return this.apiService.post(ApiEndpoints['auth.login.refresh']);
    }
}
